import { useHmoPlan } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormButton, FormInputField, Modal, SelectInputField, TextAreaField } from '@ui'
import { getError, showToast } from '@util'
import { Box } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { HmoStatusOptions } from './AddHmo'

const schema = yup.object({
  name: yup.string().required('Name is required'),
  description: yup.string(),
  status: yup.string()
})

type Props = {
  onClose: () => void
  id?: string
  defaultData?: unknown
  hmoId?: string
}

export const NewPlan = ({ onClose, defaultData, id, hmoId }: Props) => {
  const methods = useForm({ resolver: yupResolver(schema), values: defaultData as yup.InferType<typeof schema> })
  const { createHmoPlan, updateHmoPlan } = useHmoPlan()
  const { handleSubmit, formState } = methods
  const onSubmit = async (formRecObj: yup.InferType<typeof schema>) => {
    const payload = {
      data: {
        type: 'hmo_plan',
        attributes: {
          ...formRecObj
        },
        ...(hmoId && {
          relationships: {
            hmo: {
              data: {
                id: hmoId,
                type: 'hmo'
              }
            }
          }
        })
      }
    }

    try {
      id ? await updateHmoPlan({ id, formVal: payload }) : await createHmoPlan(payload)
      showToast(`Hmo plan ${id ? 'updated' : 'created'} successfully`)
      onClose()
    } catch (error) {
      getError(error)
    }
  }
  return (
    <FormProvider {...methods}>
      <Modal onClose={onClose} title={id ? 'Edit Plan' : 'Add New Plan'}>
        <form className="flex flex-col overflow-auto max-h-[88vh] min-w-[450px]" onSubmit={handleSubmit(onSubmit)}>
          <Box flex={false} gap={'20px'} overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }}>
            <div>
              <FormInputField label="Name" name="name" />
            </div>
            <div>
              <TextAreaField label="Description" name="description" />
            </div>
            <SelectInputField
              label="Status"
              labelKey={({ label }) => label}
              name="status"
              options={HmoStatusOptions}
              valueKey={{ key: 'value', reduce: true }}
            />
          </Box>
          <FormButton isLoading={formState.isSubmitting} onClose={onClose} submit="Save" />
        </form>
      </Modal>
    </FormProvider>
  )
}
